// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 320px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(max-width: 1024px)";
var _5 = "container-9VUtH";
var _6 = "segment__container-27onp";
var _7 = "checkinCardItem__container-3ql67";
var _8 = "root-2EE98";
var _9 = "flight-tB_VP";
var _a = "flight_selected-1acQs";
var _b = "readonly-1tDEi";
var _c = "infoMessage-2dwsp";
var _d = "infoMessage__htmlMessage-1TcrZ";
var _e = "segments-12YfR";
var _f = "checkinCardItem__content-3aspH";
var _10 = "subsidies-3L_YD";
var _11 = "selected-2PM69";
var _12 = "flight_canceled-Qeh27";
var _13 = "canceled-2VWxQ";
var _14 = "expand-1rMsW";
var _15 = "price__close-2PzUF";
var _16 = "expand_open-2XyGT";
var _17 = "segments_expanded-3NxqB";
var _18 = "segment-3EAps";
var _19 = "price-HjHoo";
var _1a = "price__from-177GP";
var _1b = "price__money-29wuK";
var _1c = "price__miles-2nYun";
var _1d = "currency-1Qo9a";
var _1e = "miles__taxes-_iB39";
var _1f = "price__text-1DsKf";
var _20 = "flight_withAircraft-36pGM";
var _21 = "selectedFare-oLs4u";
var _22 = "selectedFare__priceWrapper-TSpNB";
var _23 = "selectedFare__price-1h3C2";
var _24 = "stopPoint-2Dp50";
var _25 = "totalDuration-3Mmjg";
var _26 = "price_original-m0T7o";
var _27 = "price_originalMoney-1Evg3";
var _28 = "price__wrapper-2U1Al";
var _29 = "transitTariff-1suHM";
var _2a = "subStatus-2OJSj";
var _2b = "flightInfoMessage-1lS2Y";
var _2c = "flightInfoMessage__htmlMessage-3IxEw";
var _2d = "expanded-OeqIE";
var _2e = "segments__expanded-29Oy8";
var _2f = "stopsInfo-kwqws";
export { _1 as "__esModule", _2 as "iphone5", _3 as "mobile", _4 as "tablet", _5 as "container", _6 as "segment__container", _7 as "checkinCardItem__container", _8 as "root", _9 as "flight", _a as "flight_selected", _b as "readonly", _c as "infoMessage", _d as "infoMessage__htmlMessage", _e as "segments", _f as "checkinCardItem__content", _10 as "subsidies", _11 as "selected", _12 as "flight_canceled", _13 as "canceled", _14 as "expand", _15 as "price__close", _16 as "expand_open", _17 as "segments_expanded", _18 as "segment", _19 as "price", _1a as "price__from", _1b as "price__money", _1c as "price__miles", _1d as "currency", _1e as "miles__taxes", _1f as "price__text", _20 as "flight_withAircraft", _21 as "selectedFare", _22 as "selectedFare__priceWrapper", _23 as "selectedFare__price", _24 as "stopPoint", _25 as "totalDuration", _26 as "price_original", _27 as "price_originalMoney", _28 as "price__wrapper", _29 as "transitTariff", _2a as "subStatus", _2b as "flightInfoMessage", _2c as "flightInfoMessage__htmlMessage", _2d as "expanded", _2e as "segments__expanded", _2f as "stopsInfo" }
export default { "__esModule": _1, "iphone5": _2, "mobile": _3, "tablet": _4, "container": _5, "segment__container": _6, "checkinCardItem__container": _7, "root": _8, "flight": _9, "flight_selected": _a, "readonly": _b, "infoMessage": _c, "infoMessage__htmlMessage": _d, "segments": _e, "checkinCardItem__content": _f, "subsidies": _10, "selected": _11, "flight_canceled": _12, "canceled": _13, "expand": _14, "price__close": _15, "expand_open": _16, "segments_expanded": _17, "segment": _18, "price": _19, "price__from": _1a, "price__money": _1b, "price__miles": _1c, "currency": _1d, "miles__taxes": _1e, "price__text": _1f, "flight_withAircraft": _20, "selectedFare": _21, "selectedFare__priceWrapper": _22, "selectedFare__price": _23, "stopPoint": _24, "totalDuration": _25, "price_original": _26, "price_originalMoney": _27, "price__wrapper": _28, "transitTariff": _29, "subStatus": _2a, "flightInfoMessage": _2b, "flightInfoMessage__htmlMessage": _2c, "expanded": _2d, "segments__expanded": _2e, "stopsInfo": _2f }
